import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pwp303Api, QueryResponse } from '../../../services/pwp303Api';
import type { QueryRequest } from '../../../services/pwp303Api';

export interface PWP303QueryState {
  loading: boolean;
  result: QueryResponse | null;
  queried: boolean;
  noData: boolean;
}

export interface PWP303QueryActions {
  runQuery: (req: QueryRequest) => Promise<void>;
  reset: () => void;
}

export function usePWP303Query(): PWP303QueryState & PWP303QueryActions {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<QueryResponse | null>(null);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (req: QueryRequest) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await pwp303Api.query(req);
      if (resp.data && resp.data.length > 0) {
        setResult(resp);
        setNoData(false);
      } else {
        setResult(null);
        setNoData(true);
        message.info('查無符合條件的資料');
      }
      setQueried(true);
    } catch (err: unknown) {
      const axiosErr = err as { response?: { status?: number; data?: { error?: string } } };
      if (axiosErr.response?.status === 400) {
        message.error(axiosErr.response.data?.error || '查詢條件錯誤');
      } else {
        message.error('查詢失敗，請稍後再試');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResult(null);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, result, queried, noData, runQuery, reset };
}
